import { render, staticRenderFns } from "./vlogskill.vue?vue&type=template&id=b3bf8b74&scoped=true&"
import script from "./vlogskill.vue?vue&type=script&lang=js&"
export * from "./vlogskill.vue?vue&type=script&lang=js&"
import style0 from "./vlogskill.vue?vue&type=style&index=0&id=b3bf8b74&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3bf8b74",
  null
  
)

export default component.exports